import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CollectionListComponent } from './collection-list/collection-list.component';
import { CollectionComponent } from './collection/collection.component';


import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: CollectionListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewCollections, undefined))]
  },
  {
    path: 'Collection/Detail/:id',
    component: CollectionComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateUpdateCollections, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class CollectionsRoutingModule {

}
